import Model from "./base/model";

class SimulationQuotesTransporters extends Model {
  resourceName() {
    return "simulation_quotes_transporters";
  }

  fields() {
    return {
      simulation_quote_id: "",
      transporter_id: "",
      response: "",
      created_at: "",
      observation: "",
      weight: "",
      bulk: "",
      cubage: "",
      invoice_value: "",
      description_material: "",
      packaging_type: "",
      collection_date_time: "",
      delivery_date_time: "",
      services: "",
      items: "",
      modal: "",
      dangerous_products: "",
      weight_air: "",
      cubage_air: "",
      vehicle_type_id: "",
      delivery: "",
      collect: "",
      files: "",
      invoices: "",
      weight_shipping_value: "",
      order_id: "",
      icms: "",
      rates: "",
      accept: "",
      confirm: "",
      order: {jsonApi: "hasOne", type: "orders"},
      transporter: {jsonApi: "hasOne", type: "transporters"},
      simulation_quote: {jsonApi: "hasOne", type: "simulation_quotes"},
      company: {jsonApi: "hasOne", type: "shippers"},
      vehicle_type: { jsonApi: "hasOne", type: "vehicle_types"},
      simulation_quotes_transporters: { jsonApi: "hasMany", type: "simulation_quotes_transporters_addresses"},
      addresses: "",
      quotation_api_response: "",
      response_time_limit: "",
      user_id: "",
      user: {jsonApi: "hasOne", type: "users"},
      vehicle_options: "",
      vehicle_option_ids: "",
      transporter_delivery_time: "",
      shipper_order_code: "",
      transporter_accept: "",
      transporter_refuse_justification: "",
      route_km:"",
      quote_name:"",
      correios_modal_transport_id: "",
      correios_modal_transport: { jsonApi: "hasOne", type: "correios_modals_transport"},
      is_simulation: "",
      simulation: "",
      jadlog_modality: "",
      justification: "",
      awaiting_approver_user: "",
      approver_user_decline_justification: "",
      is_order_deleted: "",
      is_traceable: "",
      risk_manager: {jsonApi: "hasOne", type: "risk_managers"},
    };
  }

  async get(filters) {
    return this.request(
      this.resourceName(),
      "GET",
      filters
    );
  }

  async getId(id, filters) {
    return this.request(
      this.resourceName() + `/${id}`,
      "GET",
      filters
    );
  }

  async acceptShipper(id, data) {
    return this.request(
      this.resourceName() + `/accept/${id}`,
      "PATCH",
      {},
      data
    );
  }

  async confirmTransporter(id, data) {
    return this.request(
      this.resourceName() + `/confirm/${id}`,
      "PATCH",
      {},
      data
    );
  }

  async createOrder(id, data) {
    return this.request(
      this.resourceName() + `/create_order/${id}`,
      "PATCH",
      {},
      data
    );
  }

  async transporterAccept(id, data) {
    return this.request(
      this.resourceName() + `/transporter_accept/${id}`,
      "PATCH",
      {},
      data
    );
  }

  async getByHash(hash,params) {
    return this.request(
      this.resourceName()+"/get_by_hash/"+hash,
      "GET",
      params
    )
  }

  async confirmByHash(hash,data) {
    return this.request(
      this.resourceName()+"/confirm_by_hash/"+hash,
      "PATCH",
      {},
      data
    )
  }

  async createOrderWithHash(hash, data) {
    return this.request(
      this.resourceName() + `/create_order_by_hash/${hash}`,
      "PATCH",
      {},
      data
    );
  }

  async approverDecline(id, data) {
    return this.request(
      this.resourceName() + `/approver_decline/${id}`,
      'PATCH',
      {},
      data
    );
  }
}

export default new SimulationQuotesTransporters();
